/* eslint-disable react/jsx-props-no-multi-spaces */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Card, CardContent, ClickAwayListener, useMediaQuery, withStyles,
} from '@material-ui/core';

import { CardHeader } from '../../../components';

import Actions from './actions';

const styles = {
  cardContent: {
    position: 'relative',
    overflowY: 'auto',
  },
  overlay: {
    backgroundColor: 'rgba(255,255,255,0.85)',
    position: 'absolute',
    zIndex: 1000,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: '15px 15px',
  },
  sortButton: {
    padding: '0',
    marginLeft: '5px',
  },
  widgetWrapper: {
    flex: 'auto',
  },
  first: {
    boxShadow:
      `0 2px 2px -2px rgb(0 0 0 / 20%),
      0 -2px 2px -2px rgb(0 0 0 / 20%),
      -2px 0 2px -2px rgb(0 0 0 / 20%)`,
  },
  middle: {
    boxShadow:
      `0 2px 2px -2px rgb(0 0 0 / 20%),
      0 -2px 2px -2px rgb(0 0 0 / 20%),
      2px 0 2px -2px rgb(0 0 0 / 20%)`,
    borderRadius: '0',
  },
};

function WidgetWrapper(props) {
  const [overlayVisible, setOverlayVisible] = useState(false);
  const useDesktopLayout = useMediaQuery('(min-width:1200px)');
  const useMultiLocationComparison = useSelector(state => state.filter.useMultiLocationComparison);

  const {
    classes, title, container, width, children, visualizerOptions, setVisualizerOptions, alternative, onNextAlternative,
    exportCsv, dataIsEmpty, inApp, gridColumn, gridRow,
  } = props;

  const setSortAttribute = (sortByAttribute) => {
    setVisualizerOptions({
      ...visualizerOptions,
      sortByAttribute,
    });
  };

  const setCompareToTotal = (compareToTotal) => {
    setVisualizerOptions({
      ...visualizerOptions,
      compareToTotal,
    });
  };

  const setShowThresholdOnly = (showThresholdOnly) => {
    setVisualizerOptions({
      ...visualizerOptions,
      showThresholdOnly,
    });
  };


  const w = useDesktopLayout && !useMultiLocationComparison ? `calc(${100 / 12 * width}% - ${width * 10}px` : '100%';
  const s = {
    ...styles.widgetWrapper,
    width: w,
    margin: useDesktopLayout ? '10px' : '0 0 10px 0',
    gridColumn,
    gridRow,
  };

  const getShadowClass = (column) => {
    if (!column) {
      return null;
    }

    if (column === 1) {
      return { root: classes.first };
    }

    return { root: classes.middle };
  };

  if (container === 1) {
    return (
      <Card style={s} elevation={(gridColumn || inApp) ? 0 : 4} classes={getShadowClass(gridColumn)}>
        <CardHeader
          title={!gridColumn || gridColumn === 1 ? title : ''}
          action={(
            <Actions
              alternative={alternative}
              onNextAlternative={onNextAlternative}

              sortByAttribute={visualizerOptions.sortByAttribute}
              sortableAttributes={visualizerOptions.sortableAttributes}
              setSortAttribute={setSortAttribute}
              useDesktopLayout={useDesktopLayout}

              description={visualizerOptions.description}
              overlayVisible={overlayVisible}
              setOverlayVisible={setOverlayVisible}

              compareToTotal={visualizerOptions.hideProgress ? null : visualizerOptions.compareToTotal}
              setCompareToTotal={setCompareToTotal}

              exportCsv={(!inApp && visualizerOptions.canExport) ? exportCsv : null}
              dataIsEmpty={dataIsEmpty}

              showThresholdOnly={visualizerOptions.showThresholdOnly}
              setShowThresholdOnly={setShowThresholdOnly}
            />
          )}
        />
        <CardContent style={styles.cardContent}>
          {overlayVisible
          && (
          <ClickAwayListener onClickAway={() => setOverlayVisible(false)}>
            <div style={styles.overlay} onClick={() => setOverlayVisible(false)} onKeyDown={() => setOverlayVisible(false)}>
              {visualizerOptions.description}
            </div>
          </ClickAwayListener>
          )}
          {children}
        </CardContent>
      </Card>
    );
  }
  return (
    <div style={s} className="noContainer">
      {children}
    </div>
  );
}

WidgetWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  container: PropTypes.number,
  width: PropTypes.number,
  visualizerOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  alternative: PropTypes.string,
  dataIsEmpty: PropTypes.bool,
  setVisualizerOptions: PropTypes.func.isRequired,
  onNextAlternative: PropTypes.func.isRequired,
  exportCsv: PropTypes.func,
  inApp: PropTypes.bool,
  gridColumn: PropTypes.number,
  gridRow: PropTypes.number,
};

WidgetWrapper.defaultProps = {
  alternative: null,
  title: '',
  container: 0,
  width: 12,
  visualizerOptions: [],
  children: [],
  dataIsEmpty: false,
  exportCsv: null,
  inApp: false,
  gridColumn: null,
  gridRow: null,
};

export default withStyles(styles)(WidgetWrapper);
